export default __webpack_public_path__ + "static/logo-07d9804119669a4dc108c59eb96c6807.png";